import $ from "jquery";
import { slick } from "slick-carousel";
// Noui Slider
// Based on: http://jsfiddle.net/gabrieleromanato/EaxKs/
$.fn.rotator = function (options) {
  options = $.extend(
    {
      blocks: ".hero__slides__slide",
      speed: 1000,
      fade: 1000,
    },
    options,
  );

  var setZIndex = function (element) {
    var index = $(options.blocks, element).length;
    $(options.blocks, element).each(function () {
      index--;
      $(this).css("zIndex", index);
    });
  };

  var rotate = function (element) {
    var blocks = $(options.blocks, element),
      len = blocks.length,
      index = -1;

    blocks.fadeIn(options.fade);

    var timer = setInterval(function () {
      index++;
      var block = blocks.eq(index);
      if (index == len - 1) {
        clearInterval(timer);
        rotate(element);
      }
      if (block.index() != len - 1) {
        block.fadeOut(options.fade);
      }
    }, options.speed);
  };

  return this.each(function () {
    var elem = $(this);
    setZIndex(elem);
    rotate(elem);
  });
};

export default function slider() {
  $(".hero__slides").rotator({
    speed: 7000,
    fade: 1000,
  });
}

// Slick Slider
$(document).ready(function () {
  $(".artwork__gallery").slick({
    centerMode: true,
    centerPadding: "160px",
    slidesToShow: 1,
    infinite: true,
    variableWidth: true,
    speed: 900,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
          variableWidth: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
          variableWidth: true,
        },
      },
    ],
  });
});
